import { useCallback, useState } from 'react'

import { useMounted } from '../../../Hooks/useMounted'
import { ShipmentTrackingAPI, ShipmentTrackingResponse } from '../../../Services/API/ShipmentTrackingAPI'
import { ServiceLocator } from '../../../Services/ServiceLocator'

export const useGetShipmentTrackingDetails = () => {
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState<
    Record<string, string> | Record<string, string>[]
  >(null)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const getShipmentTrackingDetails = useCallback(
    async (srNumber: string): Promise<ShipmentTrackingResponse[]> => {
      setProcessing(true)
      return ServiceLocator.resolve(ShipmentTrackingAPI)
        .getTrackingDetails(srNumber)
        .then((response) => {
          if (mounted.current) {
            setProcessing(false)
            setErrors(null)
            setErrorMessage(null)
          }
          return response
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setErrorMessage(err?.response?.data?.errorMessage)
            setErrors(err?.response?.data?.errors)
            throw err
          }
          return null
        })
    },
    [mounted],
  )

  return {
    processing,
    errors,
    errorMessage,
    getShipmentTrackingDetails,
  }
}
